import { Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
    downloadTrackerProgressCsv,
    type TrackerProgressExportContext,
} from '@/lib/trackerProgressExport';

interface TrackerProgressExportButtonProps {
    csv: string;
    filenameStem: string;
    disabled?: boolean;
    label?: string;
}

export function TrackerProgressExportButton({
    csv,
    filenameStem,
    disabled = false,
    label = 'Export CSV',
}: TrackerProgressExportButtonProps) {
    return (
        <Button
            type="button"
            variant="outline"
            size="sm"
            className="h-9 gap-2"
            disabled={disabled}
            onClick={() => downloadTrackerProgressCsv(csv, filenameStem)}
        >
            <Download className="h-4 w-4" />
            {label}
        </Button>
    );
}

export function buildTrackerExportFilenameStem(
    view: 'stores' | 'campaigns',
    cycleName: string,
): string {
    const safeCycle = cycleName.toLocaleLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    return `reactor-cockpit-${view}-${safeCycle || 'cycle'}`;
}

export type { TrackerProgressExportContext };
